/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
const a = 'is-active';
const v = 'is-visible';

/**
 * ローカルナビゲーションの現在ページにアクティブ状態を付与
 */
const setLocalNavActiveState = () => {
	const localNavLinks = document.querySelector('.js-LocalNavLinks');
	console.log('Setting active state for local navigation links...');

	if (!localNavLinks) return;

	const currentPath = window.location.pathname;
	const links = localNavLinks.querySelectorAll('a');

	links.forEach(link => {
		const linkPath = new URL(link.href, window.location.origin).pathname;
		if (linkPath === currentPath) {
			link.classList.add(a);
		}
	});
};

// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

const corporateFUNCTIONS = () => {
	setLocalNavActiveState();
};

document.addEventListener('DOMContentLoaded', () => {
	if (window.FUNCTIONS?.localDecision()) {
		document.addEventListener('localincludeLoaded', () => { corporateFUNCTIONS(); });
	} else {
		corporateFUNCTIONS();
	}
});
